/* eslint-disable camelcase */

import { ArchiveDeleteResponse } from "components/common/ArchiveDialog/ArchiveDialog";
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { useSwr, axiosInst } from "./axiosWIS";

export interface Category extends Record<string, unknown> {
  id: string;
  cat_name: string;
  cat_desc: string;
  cat_status: string;
  incident_type_count: number;
  pk_cat_id: number;

  created_by: string;
  create_timestamp: string;
  update_by: string;
  update_timestamp: string;

  version: number;
}

export interface ArchiveCategoryResponse extends ArchiveDeleteResponse<number> {
  detail: {
    succeed: number[];
    failed: number[];
  };
}

const baseKey = "/api/Category";

export const useCategories = (
  params?: {
    pageNr?: number;
    pageSize?: number;
    orderBy?: string;
    Order?: string;
    SearchKey?: string;
  },
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<Category>> =>
  useSwr<ApiArrayResponse<Category>>(
    `${baseKey}${
      params?.pageNr && params?.pageSize
        ? `?pageNr=${params?.pageNr}&pageSize=${params?.pageSize}`
        : ""
    }${params?.orderBy != null ? `&orderBy=${params.orderBy}` : ""}${
      params?.Order != null ? `&Order=${params.Order}` : ""
    }${params?.SearchKey ? `&SearchKey=${params.SearchKey}` : ""}`,
    config
  );

export const addCategory = async (
  data: Partial<Category>
): Promise<Category> => {
  const res = await axiosInst.post(baseKey, data);
  return res.data;
};

export const editCategory = async (data: Category): Promise<unknown> => {
  const res = await axiosInst.put(`${baseKey}/${data.pk_cat_id}`, data);
  return res.data;
};

export const archiveCategory = async (
  id: string
): Promise<ArchiveCategoryResponse> => {
  const res = await axiosInst.delete(baseKey, { data: [id] });
  return res.data;
};
